import { fetchDriversBootstrap } from '@/api/driversApi';
import { fetchDashboardStats } from '@/api/dashboardApi';

export default {
  namespaced: true,
  state: {
    bootstrap: null,
    dashboardStats: null,
    allowedTabs: [],
    currentUserRole: null,
    loaded: false,
    loading: false,
    error: null
  },
  getters: {
    counts: (state) => state.bootstrap?.counts || {},
    roleTabs: (state) => state.bootstrap?.roleTabs || {},
    roleDefaultTab: (state) => state.bootstrap?.roleDefaultTab || {}
  },
  mutations: {
    setLoading(state, value) {
      state.loading = !!value;
    },
    setBootstrap(state, payload) {
      state.bootstrap = payload?.data || null;
      state.allowedTabs = Array.isArray(payload?.meta?.allowedTabs) ? payload.meta.allowedTabs : [];
      state.currentUserRole = payload?.meta?.currentUserRole || null;
      state.loaded = !!payload?.data;
      state.error = null;
    },
    setDashboardStats(state, payload) {
      state.dashboardStats = payload || null;
    },
    setBootstrapError(state, message) {
      state.error = message || null;
      state.loaded = false;
    },
    clearBootstrap(state) {
      state.bootstrap = null;
      state.dashboardStats = null;
      state.allowedTabs = [];
      state.currentUserRole = null;
      state.loaded = false;
      state.loading = false;
      state.error = null;
    }
  },
  actions: {
    async fetchBootstrap({ commit, rootState }) {
      const token = rootState.users?.user?.token || localStorage.getItem('srToken');
      if (!token) {
        commit('clearBootstrap');
        return false;
      }

      commit('setLoading', true);
      try {
        const payload = await fetchDriversBootstrap(token);
        commit('setBootstrap', payload);
        return true;
      } catch (e) {
        commit('setBootstrapError', e?.message || 'Bootstrap failed');
        return false;
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchDashboardStats({ commit, rootState }) {
      const token = rootState.users?.user?.token || localStorage.getItem('srToken');
      if (!token) {
        commit('setDashboardStats', null);
        return false;
      }

      try {
        const data = await fetchDashboardStats();
        commit('setDashboardStats', data);
        return true;
      } catch {
        return false;
      }
    }
  }
};
